import { IUIState } from './IUIState';
import { Random } from '../../Utility/Random';
import { PopupID } from './PopupID';
import { OnShowProps } from './UIActions';
import { deprecate } from 'util';
import { IGameState } from 'State/Game/IGameState';

export default class UIStateHelper {
    /**
     * @deprecated Use hidePopupFullState instead
     */
    public static showPopup(state: IUIState, popupID: string, params: any): IUIState {
        return {
            ...state,
            id: Random.ID(),
            popupID: popupID,
            params: params,
        };
    }

    // TODO: Rename to showPopup once all other uses have been updated and logic has been moved over
    public static showPopupFullState(state: IGameState, popupID: string, params: any): IGameState {
        return {
            ...state,
            UIState: this.showPopup(state.UIState, popupID, params),
        };
    }

    // TODO: Rename to hidePopup once all other uses have been updated and logic has been moved over
    public static hidePopupFullState(state: IGameState, popupID: string, params: any = {}): IGameState {
        return {
            ...state,
            UIState: this.hidePopup(state.UIState, popupID, params),
        };
    }

    /**
     * @deprecated Use hidePopupFullState instead
     */
    public static hidePopup(state: IUIState, popupID: string, params: any = {}): IUIState {
        if (popupID === state.popupID) {
            if (state.queue.length > 0) {
                return UIStateHelper.nextPopup(state);
            } else {
                return {
                    ...state,
                    id: null,
                    popupID: null,
                    params: params,
                };
            }
        }
        return state;
    }

    public static queuePopup(state: IUIState, popupID: string, params: any): IUIState {
        return {
            ...state,
            queue: [
                ...state.queue,
                {
                    id: Random.ID(),
                    popupID: popupID,
                    params: params,
                },
            ],
        };
    }

    public static requeueCurrentPopup(
        state: IGameState,
        queueNext: boolean = true,
        blacklistPopupIds: PopupID[]
    ): IGameState {
        const hasCurrentPopup = !!state.UIState.popupID;
        if (!hasCurrentPopup || blacklistPopupIds.includes(state.UIState.popupID as PopupID)) return state;

        const queue = state.UIState.queue.slice();
        const popupData = {
            id: state.UIState.id,
            popupID: state.UIState.popupID,
            params: state.UIState.params,
        };
        return {
            ...state,
            UIState: {
                ...state.UIState,
                queue: queueNext ? [popupData, ...queue] : [...queue, popupData],
            },
        };
    }

    public static updateParams<PopupType extends PopupID>(
        state: IUIState,
        id: string,
        popupType: PopupType,
        params: OnShowProps<PopupType>
    ): IUIState {
        return {
            ...state,
            // Update params if the current active popup
            ...(state.id === id
                ? {
                      params,
                  }
                : {
                      // Update popup in queue if not the current active popup
                      queue: state.queue.map(popup => {
                          return popup.id === id
                              ? {
                                    ...popup,
                                    params,
                                }
                              : popup;
                      }),
                  }),
        };
    }

    public static nextPopup(state: IUIState): IUIState {
        return {
            ...state,
            id: state.queue[0].id,
            popupID: state.queue[0].popupID,
            params: state.queue[0].params,
            queue: state.queue.slice(1),
        };
    }
}
